import React, { useState, useEffect, useRef } from 'react';
import { Badge } from 'react-bootstrap';
import ChatModal from './ChatModal';
import api from '../../services/api';
import './ChatButton.css';

const ChatButton = () => {
  const [showChat, setShowChat] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // prevUnreadCount НЕ викликає ререндер, тому працює як треба
  const prevUnreadCount = useRef(-1);

  useEffect(() => {
    loadUnreadCount();
    const interval = setInterval(loadUnreadCount, 10000);
    return () => clearInterval(interval);
  }, []);

  const loadUnreadCount = async () => {
    try {
      const response = await api.get('/chat/messages?limit=1');
      const newCount = response.data.unread_count || 0;

      // Перевіряємо збільшення
      if (prevUnreadCount.current >= 0 && newCount > prevUnreadCount.current) {
        setTimeout(() => setShowChat(true), 500);
      }

      // Оновлюємо попереднє значення
      prevUnreadCount.current = newCount;

      setUnreadCount(newCount);
    } catch (error) {
      console.error('Failed to load unread count:', error);
    }
  };

  const handleOpen = () => {
    setShowChat(true);
    setUnreadCount(0);
  };

  return (
    <>
      <div className="chat-button-container" onClick={handleOpen}>
        <div className={`chat-button ${unreadCount > 0 ? 'has-unread' : ''}`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
          </svg>
          {unreadCount > 0 && (
            <Badge bg="danger" className="chat-badge">
              {unreadCount > 99 ? '99+' : unreadCount}
            </Badge>
          )}
        </div>
      </div>
      <ChatModal 
        show={showChat} 
        onHide={() => setShowChat(false)}
        onNewMessage={loadUnreadCount}
      />
    </>
  );
};

export default ChatButton;
